<template>
  <ModalDialog
    ref="dialog"
    :title="title"
    :submitting="submitting"
    submitTitle="Confirm"
    icon="fa-dolly-flatbed"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="dialogForm" :labelColumnSize="3">
      <NotificationBar type="warning" v-if="containsMissingBatchInfo()">
        <NotificationBarTitle>The following warnings were found in the receiving list:</NotificationBarTitle>
        <NotificationBarItem v-if="containsMissingBatchInfo()">Some goods have missing supplier batch details</NotificationBarItem>
      </NotificationBar>

      <NotificationBar type="warning" v-if="isDespatchDelivery">
        <NotificationBarTitle>This will process the received goods into the inventory system. This action cannot be undone</NotificationBarTitle>
      </NotificationBar>

      <NotificationBar type="warning" v-if="isDespatchPickup">
        <NotificationBarTitle>This will process the goods into the system. This is required to be completed prior to pickup. This action cannot be undone</NotificationBarTitle>
      </NotificationBar>
      
      <FormRow label="Goods Processing Notes">
        <FormInputTextArea v-model="info.notes" field="notes" placeholder="Notes" large />
      </FormRow>
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import ModalDialogMixin from '@/mixins/modalDialog'

import { DespatchTypes } from '@/store/types'

export default {
  name: 'GoodsReceivedDialog',
  mixins: [
    ModalDialogMixin,
    form
  ],
  components: {
    ModalDialog,
  },
  props: {
    purchaseOrder: Object,
    purchaseOrderId: Number,
    goodsReceivedList: Array
  },
  data() {
    return {
      responseInfo: {},
      dialogForm: {},
      submitting: false,
      info: {}
    }
  },
  mounted() {    
  },
  computed: {
    title() {
      if(this.isDespatchPickup)
        return 'Confirm Goods For Pickup'
      return 'Confirm Goods Received'
    },
    isDespatchDelivery() {
      return this.purchaseOrder.despatchType == DespatchTypes.delivery
    },
    isDespatchPickup() {
      return this.purchaseOrder.despatchType == DespatchTypes.pickup
    },
  },
  methods: {
    show() {
      // Reset form
      this.responseInfo = { }
      this.dialogForm = { }

      return ModalDialogMixin.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      this.submitting = true

      var receivingDetails = {
        notes: this.info.notes
      }

      this.$apiService.purchasingService.completePurchaseOrderGoodsReceived(this.$route.params.id, receivingDetails)
      .then(response => {
        this.modalClosed(true)
        this.hide()
      })
      .catch(err => {
        this.$data.dialogForm = this.processFormResponse(err)
      })
      .finally(() => {
        this.$data.submitting = false
      })
    },

    containsMissingBatchInfo() {
      if(!this.goodsReceivedList)
        return false
      return this.goodsReceivedList.filter(item => {
        if((item.supplierBatchRef == null || item.supplierBatchRef == '')) {
          if(item.isBlock && parseInt(item.blockSize) > 0)
            return true
          if(!item.isBlock && item.quantity > 0)
            return true
        }
        return false
      }).length > 0
    }
  }
}
</script>